import DropDownComponent from 'app_components/commons/DropDownComponent/DropDownComponent'
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent'
import React, { FC, ReactElement, useCallback, useEffect, useMemo, useState } from 'react'

import './StudentDashboardSelectCourse.scss'
import { IMyCourse, IMyCourseTab } from 'app_types/campus/academic/myCoursesTypes';
import CourseService from 'app_services/campus/academic/courseService';
import { useDispatch, useSelector } from 'react-redux';
import { CombinedReducers } from 'app_events/index';
import { courseSelectedChange, courseTabChange } from 'app_events/courses/actions';
import AlertComponent from 'app_components/commons/alert';
import LoginMoodle from 'app_components/modules/LoginMoodle/LoginMoodle';
import { external_api } from 'app_config/globals';

export enum SelectCourseType {
  HISTORY = 'history',
  CURRENT = 'current',
}

interface IStudentDashboardSelectCourseProps {
  courseType: SelectCourseType
  children?: ReactElement
  alertText?: string
}

const StudentDashboardSelectCourse: FC<IStudentDashboardSelectCourseProps> = ({ courseType, children, alertText }) => {
  const [courses, setCourses] = useState<IMyCourse[]>([])
  const courseService = useMemo(() => new CourseService(), [])
  const auth = useSelector((state: CombinedReducers) => state.auth)
  const dispatch = useDispatch()
  const { courseSelected } = useSelector((state: CombinedReducers) => state.courses)
  const moodleId = useMemo(() => auth?.user?.data?.moodle?.moodle_id, [auth])

  const getCourses = useCallback(async () => {
    const dataResponse = await courseService.fetchMyCourses({userid: moodleId})
    if (dataResponse) {
      if (courseType === SelectCourseType.CURRENT) {
        setCourses(dataResponse.current_courses?.length ? [ ...dataResponse.current_courses?.sort((a, b) => a.name.localeCompare(b.name)) ] : [])
      } else if (courseType === SelectCourseType.HISTORY) {
        setCourses(dataResponse.history_courses?.length ? [ ...dataResponse.history_courses?.sort((a, b) => a.name.localeCompare(b.name)) ] : [])
      } else {
        setCourses([])
      }
    }
  }, [courseService, moodleId, courseType])

  useEffect(() => {
    getCourses()
  }, [getCourses])

  useEffect(() => {
    if (courseType === SelectCourseType.CURRENT) {
      dispatch(courseTabChange(IMyCourseTab.CURRENT_COURSES))
    } else if (courseType === SelectCourseType.HISTORY) {
      dispatch(courseTabChange(IMyCourseTab.HISTORY_COURSES))
    }
  }, [courseType, dispatch])

  const handleClickCourse = useCallback((course: IMyCourse) => {
    dispatch(courseSelectedChange(course))
  }, [dispatch])

  useEffect(() => {
    const exist = courses?.some((course) => course._id === courseSelected?._id)
    if (!exist) {
      if (courses?.length) {
        dispatch(courseSelectedChange(courses[0]))
      } else {
        dispatch(courseSelectedChange(null))
      }
    }
  }, [dispatch, courses, courseSelected])

  return (
    <div className="students-dashboard-select-course--layout">
      <div className="students-dashboard-select-course--select">
        <DropDownComponent
          classNameToggle='students-dashboard-select-course--toggle'
          className='students-dashboard-select-course--drop-down'
          title={courseSelected ? courseSelected.name : 'Selecciona un curso'}
        >
          {courses?.map((course) => (
            <DropDownComponent.Item key={course._id} onClick={() => handleClickCourse(course)}>
              {course.name}
            </DropDownComponent.Item>
          ))}
        </DropDownComponent>

        {!!courseSelected && (
          <LoginMoodle targetBlank redirectTo={`${external_api?.moodle?.url}/course/view.php?id=${courseSelected?._id}`}>
            <LabelComponent
              className='students-dashboard-select-course--enter-course'
              id='student_dashboard_join_course'
            >
              Ingresar al curso
            </LabelComponent>
          </LoginMoodle>
        )}
      </div>
      {!!children && !!courses?.length ? (
        children
      ): (
        <AlertComponent type='info' description={alertText ? alertText : 'No hay datos para mostrar'}/>
      )}
    </div>
  )
}

export default StudentDashboardSelectCourse
